import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    metaDescription = "metaDescription",
    metaKeywords = "metaKeywords",
    metaAuthor = "metaAuthor"
}

interface Props extends WidgetProps {
    fields: {
        [fields.metaDescription]: string;
        [fields.metaKeywords]: string;
        [fields.metaAuthor]: string;
    };
}

const MetaDescriptionWidget: React.FC<Props> = props => {
    return (
        <div>
            <meta name="description" content={props.fields.metaDescription}/>
            <meta name="keywords" content={props.fields.metaKeywords}/>
            <meta name="author" content={props.fields.metaAuthor}/>
        </div>
    );
};

const definition: WidgetDefinition = {
    group: "Header",
    fieldDefinitions: [
        {
            name: fields.metaAuthor,
            displayName: "Meta Author",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter meta author",
            placeholder: "Meta Author",
        },
        {
            name: fields.metaDescription,
            displayName: "Meta Description",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter meta description",
            placeholder: "Meta Description",
        },
        {
            name: fields.metaKeywords,
            displayName: "Meta Keywords",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Enter meta keywords",
            placeholder: "Meta Keywords",
        }
    ],
};

const widgetModule: WidgetModule = {
    component: MetaDescriptionWidget,
    definition,
};

export default widgetModule;